<div class="assignees-container d-flex">
  <i class="ph-fill ph-trophy"></i>
  <app-searchable-entity
    [styleClass]="styleClass"
    class="pdh-4px overflow-hidden"
    [attributeName]="'organisation'"
    [baseUrl]="environment.appBaseUrl + '/tenders/search'"
    [entityName]="firstAssignee"
  />
  @if (hasMultipleAssignees) {
    <app-assignees-popover
      [styleClass]="styleClass"
      [tender]="assigneesData"
      [tenderId]="assigneePopOverId"
      (toggleOverlay)="toggleOverlay($event)"
      (closeOverlay)="closeOverlay()"
    />
  }
</div>
